const pageNameKey = "unsavedStructureForNodeManagerNavigationModal";

export const unsavedStructureForNodeManagerNavigationModalEn = {
  [pageNameKey]: {
    subTitle: "Are you sure?",
    title: "Unsaved Structure",
    descriptionFirstLine: "Do you really want to proceed without saving?",
    descriptionSecondLine: "All unsaved changes will be discarded.",
    proceedWithoutSavingButton: "Proceed without saving",
    saveStructureButtonText: "Save and proceed",
  },
};

export const unsavedStructureForNodeManagerNavigationModalPtBr = {
  [pageNameKey]: {
    subTitle: "Tem certeza?",
    title: "Estrutura não salva",
    descriptionFirstLine: "Você realmente deseja continuar sem salvar?",
    descriptionSecondLine: "Todas as alterações não salvas serão descartadas.",
    proceedWithoutSavingButton: "Continuar sem salvar",
    saveStructureButtonText: "Salvar e continuar",
  },
};

export const unsavedStructureForNodeManagerNavigationModalDe = {
  [pageNameKey]: {
    subTitle: "Bist du sicher?",
    title: "Ungespeicherte Struktur",
    descriptionFirstLine: "Möchtest du wirklich ohne Speichern fortfahren?",
    descriptionSecondLine: "Alle ungespeicherten Änderungen gehen verloren.",
    proceedWithoutSavingButton: "Ohne Speichern fortfahren",
    saveStructureButtonText: "Speichern und fortfahren",
  },
};

export const unsavedStructureForNodeManagerNavigationModalZhHans = {
  [pageNameKey]: {
    subTitle: "你确定吗？",
    title: "未保存的结构",
    descriptionFirstLine: "你真的要在不保存的情况下继续吗？",
    descriptionSecondLine: "所有未保存的更改将被丢弃。",
    proceedWithoutSavingButton: "继续而不保存",
    saveStructureButtonText: "保存并继续",
  },
};

export const unsavedStructureForNodeManagerNavigationModalIt = {
  [pageNameKey]: {
    subTitle: "Sei sicuro?",
    title: "Struttura non salvata",
    descriptionFirstLine: "Vuoi davvero procedere senza salvare?",
    descriptionSecondLine: "Tutte le modifiche non salvate verranno eliminate.",
    proceedWithoutSavingButton: "Procedi senza salvare",
    saveStructureButtonText: "Salva e procedi",
  },
};

export const unsavedStructureForNodeManagerNavigationModalEs = {
  [pageNameKey]: {
    subTitle: "¿Estás seguro?",
    title: "Estructura sin guardar",
    descriptionFirstLine: "¿Realmente quieres continuar sin guardar?",
    descriptionSecondLine: "Se descartarán todos los cambios no guardados.",
    proceedWithoutSavingButton: "Continuar sin guardar",
    saveStructureButtonText: "Guardar y continuar",
  },
};

export const unsavedStructureForNodeManagerNavigationModalNl = {
  [pageNameKey]: {
    descriptionFirstLine: "Wilt u echt doorgaan zonder op te slaan?",
    descriptionSecondLine:
      "Alle niet-opgeslagen wijzigingen worden verwijderd.",
    proceedWithoutSavingButton: "Doorgaan zonder op te slaan",
    saveStructureButtonText: "Opslaan en doorgaan",
    subTitle: "Weet u het zeker?",
    title: "Niet-opgeslagen structuur",
  },
};

export const unsavedStructureForNodeManagerNavigationModalTr = {
  [pageNameKey]: {
    descriptionFirstLine: "Gerçekten kaydetmeden devam etmek istiyor musunuz?",
    descriptionSecondLine: "Kaydedilmemiş tüm değişiklikler silinecektir.",
    proceedWithoutSavingButton: "Kaydetmeden devam et",
    saveStructureButtonText: "Kaydet ve devam et",
    subTitle: "Emin misin?",
    title: "Kaydedilmemiş Yapı",
  },
};
